import { gql } from '@apollo/client';

export default gql`
    query workspaceHistoryQuery($orderBy: [JSON], $filterBy: [JSON], $excludeBy: [JSON], $startIndex: Int, $stopIndex: Int) {
        count: count(dataType: "workspaceChangelog", filterBy: $filterBy, excludeBy: $excludeBy)
        records: workspaceChangelogs(startIndex: $startIndex, stopIndex: $stopIndex, orderBy: $orderBy, filterBy: $filterBy, excludeBy: $excludeBy) {
            id
            workspace {
                id
                name
            }
            change
            user {
                id
                name
                image
            }
            date
        }
    }
`;
